import { useMemo } from 'react';
import { NODES_EXTRA_DATA } from '../const';
import { NodeEnum } from '../types';

export const useNodesExtraData = () => {
  return useMemo(() => {
    return Object.keys(NODES_EXTRA_DATA).reduce(
      (acc, nodeType) => {
        const nodeTypeEnum = nodeType as NodeEnum;
        acc[nodeTypeEnum] = {
          ...NODES_EXTRA_DATA[nodeTypeEnum],
          availablePrevNodes:
            NODES_EXTRA_DATA[nodeTypeEnum].getAvailablePrevNodes(),
          availableNextNodes:
            NODES_EXTRA_DATA[nodeTypeEnum].getAvailableNextNodes(),
        };
        return acc;
      },
      {} as Record<
        NodeEnum,
        {
          availablePrevNodes: NodeEnum[];
          availableNextNodes: NodeEnum[];
        }
      >,
    );
  }, []);
};

export const useAvailableBlocks = (nodeType?: NodeEnum) => {
  const nodesExtraData = useNodesExtraData();

  const availablePrevBlocks = useMemo(() => {
    if (!nodeType) return [];
    return nodesExtraData[nodeType]?.availablePrevNodes || [];
  }, [nodeType, nodesExtraData]);

  const availableNextBlocks = useMemo(() => {
    if (!nodeType) return [];
    return nodesExtraData[nodeType].availableNextNodes || [];
  }, [nodeType, nodesExtraData]);

  return useMemo(() => {
    return {
      availablePrevBlocks: availablePrevBlocks.filter((nType) => {
        return true;
      }),
      availableNextBlocks: availableNextBlocks.filter((nType) => {
        return true;
      }),
    };
  }, [availablePrevBlocks, availableNextBlocks]);
};
